import { render, staticRenderFns } from "./SvgPictoCollect.vue?vue&type=template&id=4b7b064b&scoped=true"
import script from "./SvgPictoCollect.vue?vue&type=script&lang=ts"
export * from "./SvgPictoCollect.vue?vue&type=script&lang=ts"
import style0 from "./SvgPictoCollect.vue?vue&type=style&index=0&id=4b7b064b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7b064b",
  null
  
)

export default component.exports